import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {LogoWithLabel} from '@shared/components/Logo/LogoWithLabel'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {FooterContacts} from './FooterContacts'
import {FooterContactsExternalLinks} from './FooterContactsExternalLinks'
import {FooterNavigationForServicePages} from './FooterNavigationForServicePages'

// Нижняя часть страницы со ссылками и копирайтом.
// Макет: мобильный 577:9343.
export function FooterMobile() {

    return (
        <Card className="footer-mobile">
            <CardBody className="p-4 d-flex flex-column align-items-stretch gap-4">
                <FooterContacts />
                <div className="border-top" />
                <FooterContactsExternalLinks />
                <div className="border-top" />
                <HtmlContent
                    html={trans().common.footer.copyright}
                    block
                    className="footer-copyright text-center fs-7"
                />
                <FooterNavigationForServicePages
                    className="d-flex flex-column align-items-center justify-content-start gap-4"
                />
                <div className="flex-center">
                    <LogoWithLabel
                        url={appUrl().index}
                        alt={trans().common.app_name}
                        height={24}
                    />
                </div>
            </CardBody>
        </Card>
    )
}
